import { createContext, useContext, useEffect, useState } from "react";
import {
    onAuthStateChanged,
    signInAnonymously,
    GoogleAuthProvider,
    signInWithPopup,
    signOut,
} from "firebase/auth";
import { auth, db } from "../firebase";
import { doc, getDoc, setDoc, serverTimestamp } from "firebase/firestore";
const AuthContext = createContext();

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isLoggingOut, setIsLoggingOut] = useState(false);
    const [mode, setMode] = useState(
        sessionStorage.getItem("appMode") || null
    );
    const setAppMode = (newMode) => {
        sessionStorage.setItem("appMode", newMode);
        setMode(newMode);
    };
    useEffect(() => {
        const unsub = onAuthStateChanged(auth, async (firebaseUser) => {
            if (!firebaseUser) {
                setUser(null);
                setLoading(false);
                return;
            }

            const ref = doc(db, "users", firebaseUser.uid);
            const snap = await getDoc(ref);

            if (!snap.exists()) {
                await setDoc(ref, {
                    uid: firebaseUser.uid,
                    realName: firebaseUser.displayName || "Guest",
                    dupr: firebaseUser.dupr || "",
                    displayName: firebaseUser.displayName || "Guest",
                    role: "player",
                    isAnonymous: firebaseUser.isAnonymous,
                    createdAt: serverTimestamp(),
                });
            }

            const finalSnap = await getDoc(ref);

            setUser({
                uid: firebaseUser.uid,
                ...finalSnap.data(),
            });

            setLoading(false);
        });

        return () => unsub();
    }, []);

    // ✅ USER-INITIATED guest login
    const loginGuest = () => {
        return signInAnonymously(auth);
    };

    // ✅ USER-INITIATED Google login
    const loginGoogle = () => {
        const provider = new GoogleAuthProvider();
        return signInWithPopup(auth, provider);
    };

    const logout = async () => {
        sessionStorage.removeItem("appMode");
        setIsLoggingOut(true);
        setMode(null);
        await signOut(auth);
        setIsLoggingOut(false);
    };
    return (
        <AuthContext.Provider value={{ user, setUser, loading, mode, setMode, setAppMode, loginGoogle, loginGuest, logout, isLoggingOut }}>
            {children}
        </AuthContext.Provider>
    );
}

export const useAuth = () => useContext(AuthContext);
